// Score zoom: one place for the limits and steps used by the shortcuts, the
// status-bar buttons, the settings slider and Ctrl/⌘ + wheel or pinch. The
// score view keeps the point under the anchor (pointer, else the cursor) still.

import { getState, setView } from '../state/store';

export const ZOOM_MIN = 0.5;
export const ZOOM_MAX = 3;
const STOPS = [0.5, 0.6, 0.75, 0.85, 1, 1.15, 1.3, 1.5, 1.75, 2, 2.5, 3];

/** Viewport point (relative to the score's scroll box) to hold still on the next zoom change. */
let anchor: { x: number; y: number } | null = null;

export function takeZoomAnchor(): { x: number; y: number } | null {
  const a = anchor;
  anchor = null;
  return a;
}

export function setZoom(z: number, at?: { x: number; y: number }): void {
  const zoom = Math.round(Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, z)) * 100) / 100;
  if (zoom === getState().view.zoom) return;
  anchor = at ?? null;
  setView({ zoom });
}

/** Next/previous zoom stop (Ctrl/⌘ + / −, the status-bar buttons). */
export function zoomStep(dir: 1 | -1): void {
  const z = getState().view.zoom;
  const next = dir > 0 ? STOPS.find((s) => s > z + 0.001) : [...STOPS].reverse().find((s) => s < z - 0.001);
  if (next !== undefined) setZoom(next);
}

export function resetZoom(): void {
  setZoom(1);
}
